var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateAccountLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 26.237c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.602 12.407V9.92a3.602 3.602 0 10-7.204 0v2.487a1.873 1.873 0 00-1.788 1.87v5.878h10.78v-5.878a1.873 1.873 0 00-1.788-1.87zM13 7.587a2.336 2.336 0 012.334 2.333v2.483h-4.667V9.92A2.336 2.336 0 0113 7.586z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 15.31a.969.969 0 10-1.515.801v2.106h1.09v-2.106a.967.967 0 00.424-.8z",
    fill: "#E95832"
  })));
}
export default __webpack_public_path__ + "static/media/create-account-lock.adebaae6.svg";
export { SvgCreateAccountLock as ReactComponent };